import React from "react";

const BADGE_COLORS = {
  orange: "bg-[#F7941D]",
  blue: "bg-[#0057A5]",
  emerald: "bg-emerald-500",
};

function StepBadge({ number, label, color = "blue" }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 shadow-sm ring-1 ring-slate-200">
      <span
        className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-bold text-white ${BADGE_COLORS[color]}`}
      >
        {number}
      </span>
      {label}
    </span>
  );
}

export default StepBadge;
